module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-box"
  }, [_c('div', {
    staticClass: "app-box-ewm"
  }, [_c('div', {
    staticClass: "app-box-ewm-item"
  }, [_c('div', {
    staticClass: "app-box-ewm-item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.androidImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.guojianzhuoxiazai')))]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/anzhuo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div-content"
  }, [_c('span', {
    staticClass: "app-box-ewm-item-div-content-span"
  }, [_vm._v("GET IN ON")]), _vm._v(" "), _c('span', {
    staticClass: "app-box-ewm-item-div-content-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.anzhuoxiazai')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item"
  }, [_c('div', {
    staticClass: "app-box-ewm-item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.iosImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.guojipingguoxiazai')))]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/pingguo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div-content"
  }, [_c('span', {
    staticClass: "app-box-ewm-item-div-content-span"
  }, [_vm._v("Download on the")]), _vm._v(" "), _c('span', {
    staticClass: "app-box-ewm-item-div-content-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.pingguoxiazai')))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd56ccae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appxiazai/appxiazai.vue
// module id = 995
// module chunks = 1